import { render, staticRenderFns } from "./conversation-detail.vue?vue&type=template&id=7a0f26c8&"
import script from "./conversation-detail.vue?vue&type=script&lang=ts&"
export * from "./conversation-detail.vue?vue&type=script&lang=ts&"
import style0 from "./conversation-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports